import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CartButton from '../../components/feature/CartButton';

export default function ContactPage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', phone: '', message: '' });
    }, 3000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" 
                alt="Organic Natural Solution Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors">Home</Link>
              <Link to="/about" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors">About</Link>
              <Link to="/products" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors">Products</Link>
              <Link to="/testimonials" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors">Testimonials</Link>
              <Link to="/blog" className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors">Blog</Link>
              <Link to="/contact" className="text-sm font-medium text-teal-600 transition-colors">Contact</Link>
              <CartButton />
            </div>
            <div className="flex md:hidden items-center gap-4">
              <CartButton />
              <button 
                className="cursor-pointer"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => setMobileMenuOpen(false)}>Home</Link>
              <Link to="/about" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => setMobileMenuOpen(false)}>About</Link>
              <Link to="/products" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => setMobileMenuOpen(false)}>Products</Link>
              <Link to="/testimonials" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => setMobileMenuOpen(false)}>Testimonials</Link>
              <Link to="/blog" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
              <Link to="/contact" className="block text-sm font-medium text-teal-600 transition-colors" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Get in <span className="text-teal-600">Touch</span>
            </h1>
            <p className="text-xl text-gray-600">
              Have questions? We\\'re here to help you on your wellness journey
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Contact Information</h2>
              
              <div className="space-y-8 mb-12">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-600 text-white rounded-full flex-shrink-0">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Visit Us</h3>
                    <p className="text-gray-600">#2 Allen Avenue Near Tonyin Roundabout, Ikeja, Lagos - Nigeria</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-600 text-white rounded-full flex-shrink-0">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Call Us</h3>
                    <p className="text-gray-600">+234 815 435 8746</p>
                    <p className="text-gray-600">+234 913 789 7299</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-600 text-white rounded-full flex-shrink-0">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Email Us</h3>
                    <p className="text-gray-600">hellohealthyliving@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-600 text-white rounded-full flex-shrink-0">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Business Hours</h3>
                    <p className="text-gray-600">Monday - Friday: 9:00 AM - 6:00 PM</p>
                    <p className="text-gray-600">Saturday: 10:00 AM - 4:00 PM</p>
                    <p className="text-gray-600">Sunday: Closed</p>
                  </div>
                </div>
              </div>

              <div className="rounded-3xl overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/5ff600d94ab8064ba022e1e1a6be71b5.jpeg" 
                  alt="Our Store" 
                  className="w-full h-auto object-cover object-center"
                />
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Send Us a Message</h2>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-900 mb-2">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
                    placeholder="John Doe"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-900 mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
                    placeholder="john@example.com"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-900 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
                    placeholder="+234 800 000 0000"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-900 mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent resize-none"
                    placeholder="How can we help you?"
                  />
                </div>

                <button
                  type="submit"
                  className={`w-full py-4 rounded-lg font-medium transition-all ${
                    submitted
                      ? 'bg-green-600 text-white'
                      : 'bg-teal-600 text-white hover:bg-teal-700'
                  }`}
                >
                  {submitted ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-check-line"></i>
                      Message Sent!
                    </span>
                  ) : (
                    'Send Message'
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <img src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" alt="Organic Natural Solution Logo" className="h-12 w-auto mb-6" />
              <p className="text-gray-400 leading-relaxed mb-6">
                Dedicated to providing the highest quality herbal remedies that honor traditional wisdom while meeting modern wellness needs.
              </p>
              <div className="flex gap-4">
                <a href="https://www.instagram.com/healthyliving.products?igsh=NGl6a3oxZXhrcmxr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://www.facebook.com/share/1CKjLukjVr/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
              </div>
            </div>

            <div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">LOCATION</h4>
                <p className="text-gray-400">#2 Allen Avenue Near Tonyin Roundabout, Ikeja, Lagos - Nigeria</p>
              </div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">PHONE</h4>
                <p className="text-gray-400">+234 815 435 8746</p>
                <p className="text-gray-400">+234 913 789 7299</p>
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase mb-3">EMAIL</h4>
                <p className="text-gray-400">healthyliving.hello@gmail.com</p>
              </div>
            </div>

            <div>
              <div className="rounded-2xl overflow-hidden h-80">
                <img 
                  src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6686b80771a03e2f4f8c9b19d31144a1.jpeg" 
                  alt="Organic Natural Solution" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8">
            <p className="text-sm text-gray-400 text-center">© 2025 Organic Natural Solution. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <button
        onClick={() => window.open('https://wa.me/2348154358746', '_blank')}
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center z-50 transition-all hover:scale-110 cursor-pointer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </button>
    </div>
  );
}
